import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=12d4fd13&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4fd13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d4fd13')) {
      api.createRecord('12d4fd13', component.options)
    } else {
      api.reload('12d4fd13', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=12d4fd13&scoped=true&", function () {
      api.rerender('12d4fd13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zkBf8K3p8CQo/JS/comp/Accordion.vue"
export default component.exports